import React from "react";

// Under the freemium model (#115), Level 1 of *every* game is free for
// everyone — users can sample the whole catalog. Access is now gated per
// level, not per game: the backend caps free-tier users to Level 1 and the
// in-game LevelAdvanceNotice surfaces the log-in / upgrade prompt at game over.
//
// So GameGate no longer hard-locks any game; it stays in the tree as a thin
// pass-through (and an obvious hook should per-game gating ever be needed
// again).
const GameGate = ({ children }) => children;

export default GameGate;
